export default __webpack_public_path__ + "static/media/greenArrowDownFull.77f926fa.svg";